import { useBranding } from '@lok/context/BrandingContext';
import LOGO_BLACK from '@lok/assets/ContinuumLogoBlack.svg';
import LOGO_WHITE from '@lok/assets/ContinuumLogoWhite.svg';

const LANDING_URL = 'https://www.continuumedtech.com/';

// Footer "Powered by Continuum" badge. Visible on every authenticated page,
// hidden when the active branding university is whitelabeled
// (is_whitelabel=true). The super-admin checkbox in SettingsSection /
// ClientEditModal is the inverse of this gate — see SettingsSection.jsx:76.
// `activeUniversity` follows the super-admin's viewed client, so the badge
// reflects the selected client's whitelabel setting (CON-165).
const PoweredByContinuum = () => {
  const { activeUniversity } = useBranding();

  if (activeUniversity?.is_whitelabel) return null;

  return (
    <div
      className='flex items-center justify-center gap-1.5 py-3 text-[11px] text-gray-500 dark:text-gray-400'
      data-testid='powered-by-continuum'
    >
      <span>Powered by</span>
      {/* CON-296: the logo leads to the landing page, in a new tab so a
          learner does not lose the lesson they are on. */}
      <a
        href={LANDING_URL}
        target='_blank'
        rel='noopener noreferrer'
        aria-label='Continuum (opens continuumedtech.com in a new tab)'
        className='inline-flex items-center rounded-sm opacity-90 hover:opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-green'
      >
        <img
          src={LOGO_BLACK}
          alt=''
          className='h-3 w-auto dark:hidden'
        />
        <img
          src={LOGO_WHITE}
          alt=''
          className='h-3 w-auto hidden dark:block'
        />
      </a>
    </div>
  );
};

export default PoweredByContinuum;
